import React, { FunctionComponent } from 'react';

import ShareButton from '../ShareButton/ShareButton';

import styles from '../Timeline.scss';
import { TimelineEntryProps } from './TimelineEntry';

export type FooterProps = Pick<TimelineEntryProps, 'timelineEntry'>;

export const Footer: FunctionComponent<FooterProps> = ({
  timelineEntry,
  children,
}) => {
  const { media, message } = timelineEntry;
  return (
    <div className={`${styles.actionsContainer} jg-flex-jcb`}>
      <ShareButton timelineImage={media?.[0]?.url} description={message} />
      {children}
    </div>
  );
};
Footer.displayName = 'TimelineEntryFooter';
